import {observer} from "mobx-react";
import {useServices} from "../../../../../react-hooks/use-services.hook";
import {OptInDialogHeaderBox} from "./boxes/opt-in-dialog-header.box";
import {OptInHeaderRowContainerBox} from "./boxes/opt-in-header-row-container/opt-in-header-row-container.box";
import {OptInOuterFrameBox} from "./boxes/opt-in-outer-frame/opt-in-outer-frame.box";
import {OptInLogoBox} from "./boxes/opt-in-logo/opt-in-logo.box";
import {OptInWinHighlightComponent} from "../opt-in-win-highlight/opt-in-win-highlight.component";
import {OptInWinHighlightAmountBox} from "../opt-in-win-highlight/boxes/opt-in-win-highlight-amount/opt-in-win-highlight-amount.box";
import {OptInWinHighlightLabelBox} from "../opt-in-win-highlight/boxes/opt-in-win-highlight-label/opt-in-win-highlight-label.box";
import {OptInWinHighlightFormattedMoneyBox} from "../opt-in-win-highlight/boxes/opt-in-win-highlight-amount/opt-in-win-highlight-formatted-money.box";
import {SpacerBox} from "../../../../../basic-ui-components/layout/spacer.box";


export const OptInDialogHeaderComponent: React.FC = observer(() => {
    const services = useServices();

    const renderJackpotBetFormattedMoney = (label: string, amount: number) => {
        let formattedMoney = services.currency.formatMoney(amount);
        const decimalSymbol = services.currency.getDecimalSymbol();
        const splittedMoney = formattedMoney.split(decimalSymbol);

        if (splittedMoney.length === 2) {
            return (<>
                <OptInWinHighlightLabelBox>
                    {label}
                </OptInWinHighlightLabelBox>
                <OptInWinHighlightFormattedMoneyBox className={'cy-jp-bets-widget-wins-today'}>
                    <OptInWinHighlightAmountBox >{splittedMoney[0]}</OptInWinHighlightAmountBox>
                    <OptInWinHighlightAmountBox >{decimalSymbol}</OptInWinHighlightAmountBox>
                    <OptInWinHighlightAmountBox style={{fontSize: '95%', paddingBottom: '0.3rem'}}>{splittedMoney[1]}</OptInWinHighlightAmountBox>
                </OptInWinHighlightFormattedMoneyBox>
            </>)
        } else {
            return (<>
                <OptInWinHighlightLabelBox>
                    {label}
                </OptInWinHighlightLabelBox>
                <OptInWinHighlightAmountBox className={'cy-jp-bets-widget-wins-today'}>
                    {formattedMoney}
                </OptInWinHighlightAmountBox>
            </>)
        }
    };

    const prizeWonToday = {
        render: () =>
            renderJackpotBetFormattedMoney(
                services.translation.translate('JACKPOT_BET_WON_TODAY'),
                services.jackpotBet.jackpotsInfo.totalWinsToday
            )
    };

    const prizeWinnersToday = {
        render: () =>
            <>
                <OptInWinHighlightLabelBox>
                    {services.translation.translate('JACKPOT_BET_WINNERS_TODAY')}
                </OptInWinHighlightLabelBox>
                <OptInWinHighlightAmountBox className="cy-jp-bets-widget-winners-count">
                    {services.jackpotBet.jackpotsInfo.winnersCount.toString()}
                </OptInWinHighlightAmountBox>
            </>
    };

    return (
        <OptInOuterFrameBox>
            <OptInDialogHeaderBox>
                <OptInLogoBox />
                <OptInHeaderRowContainerBox>
                    <OptInWinHighlightComponent jackpotBetWinInfo={prizeWonToday} />
                    <OptInWinHighlightComponent jackpotBetWinInfo={prizeWinnersToday} />
                </OptInHeaderRowContainerBox>
                <SpacerBox height={"12px"} />
            </OptInDialogHeaderBox>
        </OptInOuterFrameBox>
    )
})